import type {
  DocumentRelationshipKind,
  RelationshipDirection,
} from "@/types/documentRelationships";

/** Plain kind labels — used in pickers / <select> options. */
export const KIND_LABELS: Record<DocumentRelationshipKind, string> = {
  AiAnalysisOf: "AI analysis",
  SignedVersionOf: "Signed version",
  SupersededBy: "Superseded by",
  SupplementTo: "Supplement to",
  GroupedWith: "Group together",
  Other: "Other",
};

/** Kinds whose meaning depends on which document is "from" vs "to". */
export const DIRECTIONAL_KINDS: DocumentRelationshipKind[] = [
  "AiAnalysisOf",
  "SignedVersionOf",
  "SupersededBy",
  "SupplementTo",
];

/**
 * Reciprocal display label for a relationship as seen from the current
 * document, given the stored kind and the direction of the edge. Symmetric
 * relationships ignore direction; directional ones flip wording between the
 * outgoing ("from") and incoming ("to") sides.
 */
export function relationshipDisplayLabel(
  kind: DocumentRelationshipKind,
  direction: RelationshipDirection,
): string {
  if (kind === "GroupedWith") return "Grouped with";
  if (kind === "Other") return "Related to";

  switch (kind) {
    case "AiAnalysisOf":
      return direction === "incoming" ? "Source for AI analysis" : "AI analysis of";
    case "SignedVersionOf":
      return direction === "incoming" ? "Original of signed version" : "Signed version of";
    case "SupersededBy":
      return direction === "incoming" ? "Superseded by" : "Supersedes";
    case "SupplementTo":
      return direction === "incoming" ? "Supplemented by" : "Supplements";
    default:
      return KIND_LABELS[kind];
  }
}
